import React from 'react';
import { formatSeriesAccessType, SeriesAccessType } from '@modernhealth/circles-web-components';
import { useTranslation } from 'react-i18next';

export const TranslatedSeriesAccess = ({
    accessType,
}: {
    accessType: SeriesAccessType | string;
}) => {
    const { t } = useTranslation('circles');

    // t("Members only")
    // t("Open to public")
    return (
        <>
            {t(formatSeriesAccessType(accessType).defaultMessage, {
                /* Our "keys" have spaces in them, so look them up directly.*/
                ignoreJSONStructure: true,
            })}
        </>
    );
};
